// display.empty-state.v1
//
// Use this whenever a list/table/section has nothing to show. Single
// canonical look so plugins stop reinventing "no results" prose.

import { type JSX, Show, splitProps } from "solid-js"
import { Icon, type IconProps } from "../../components/icon"

export interface EmptyStateProps {
  title: string
  description?: string
  icon?: IconProps["name"]
  action?: JSX.Element
  class?: string
}

export function EmptyState(props: EmptyStateProps) {
  const [local, rest] = splitProps(props, ["title", "description", "icon", "action", "class"])

  return (
    <div
      data-registry-id="display.empty-state"
      classList={{
        "flex flex-col items-center justify-center gap-3 py-10 text-center": true,
        [local.class ?? ""]: !!local.class,
      }}
      {...rest}
    >
      <Show when={local.icon}>
        {(name) => (
          <div class="flex size-10 items-center justify-center rounded-full bg-surface-raised-base text-text-weak">
            <Icon name={name()} size="normal" />
          </div>
        )}
      </Show>
      <div class="flex flex-col gap-1 max-w-[44ch]">
        <div class="text-14-medium text-text-strong">{local.title}</div>
        <Show when={local.description}>
          <p class="text-13-regular text-text-base">{local.description}</p>
        </Show>
      </div>
      <Show when={local.action}>
        <div>{local.action}</div>
      </Show>
    </div>
  )
}
